module.exports = __webpack_public_path__ + "a7b669327180eb3a42065b045da24c20.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-high-heels-s.png
// module id = 2545
// module chunks = 0